import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { ChartInfoRespose } from './types'

export interface ChartInfoRequest {
  flatform: string | undefined
  tokenAddress: string
}

const baseUrl = 'https://api.coingecko.com/api/v3'
export const chartInfoApi = createApi({
  reducerPath: 'chartInfoApi',
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getChartInfo: builder.query<ChartInfoRespose, ChartInfoRequest>({
      query: (args) => {
        return `/coins/${args.flatform}/contract/${args.tokenAddress}`
      },
    }),
  }),
})

// Export hooks for usage in function components, which are
// auto-generated based on the defined endpoints
export const { useGetChartInfoQuery } = chartInfoApi
